export default __webpack_public_path__ + "images/256x256.png";